var ThrowStatement = {
  print: function print() {
    return 'throw;';
  }
};
module.exports = ThrowStatement;